import index from './index.js';
import { Router } from '@/legacy/Router';

Router.get('content/interface', index);
